import { createFileRoute, useParams } from '@tanstack/react-router';
import { IconEnvelopeAlt, IconRepeat } from '@maia/icons';
import { PageHeader, InfoCard, StaticNotification, ButtonLink } from '@maia/ui';

export const Route = createFileRoute(
  '/_authenticated/claims/new/_layout/$customer/external-system',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const params = useParams({
    from: '/_authenticated/claims/new/_layout/$customer/external-system',
  });

  return (
    <div className="layout-sidebar">
      <PageHeader
        title="Je bent doorgestuurd naar een extern systeem"
        description="Deze claim wordt afgehandeld via een extern portaal. Hiervoor is een nieuw tabblad geopend."
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <StaticNotification
          variant="info"
          size="small"
          className="col-span-full"
        >
          <span className="font-medium">Let op!</span> Je moet de claim nog
          voltooien in het externe systeem
        </StaticNotification>

        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconRepeat}
              title="Automatische synchronisatie"
              description="Zodra de claim is ingediend in het externe systeem, verschijnt deze automatisch in Broker Studio."
            />
          </li>
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="Bevestiging naar klant"
              description="De klant ontvangt automatisch een bevestiging zodra de claim is ingediend."
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          <ButtonLink
            to="/customers/$guid"
            params={{ guid: params.customer }}
            intent="primary"
          >
            Terug naar klant
          </ButtonLink>
        </div>
      </div>

      <div className="area-page-sidebar invisible"></div>
    </div>
  );
}
